import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarAfericaoLucro1(api, parametros) {        
    parametros.operacao = 'buscarAfericaoLucro1'

    let retorno = {}

    await api.santriPOST('/rest/afericaoLucro', parametros, 0, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  },

  async buscarAfericaoLucro2(api, parametros) {
    parametros.operacao = 'buscarAfericaoLucro2'

    let retorno = {}

    await api.santriPOST('/rest/afericaoLucro', parametros, 0, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  },

  async gerarPlanilhaAfericaoLucro1(api, parametros) {
    parametros.operacao = 'gerarPlanilhaAfericaoLucro1'

    let retorno = {}

    await api.santriPOST('/rest/afericaoLucro', parametros, 0, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);

      let parametros_planilha = {
        operacao: 'buscarPlanilhaAfericaoLucro',
        caminho_arquivo: retorno.dados.caminho_arquivo
      };

      window.location.href = (process.env.API + '/rest/afericaoLucro?' + JSON.stringify(parametros_planilha));
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RAfericaoLucro.js